import { createContext, type ReactNode, useCallback, useContext, useState } from "react";

interface SplitViewState {
  title: string;
  body: ReactNode;
  openAsPageUrl?: string;
}

interface SplitViewContextValue {
  state: SplitViewState | null;
  openSplitView: (state: SplitViewState) => void;
  closeSplitView: () => void;
}

const SplitViewContext = createContext<SplitViewContextValue | null>(null);

export function SplitViewProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SplitViewState | null>(null);

  const openSplitView = useCallback((newState: SplitViewState) => {
    setState(newState);
  }, []);

  const closeSplitView = useCallback(() => {
    setState(null);
  }, []);

  return (
    <SplitViewContext.Provider value={{ state, openSplitView, closeSplitView }}>
      {children}
    </SplitViewContext.Provider>
  );
}

export function useSplitView() {
  const context = useContext(SplitViewContext);
  if (!context) {
    throw new Error("useSplitView must be used within a SplitViewProvider");
  }
  return context;
}
